import { Select as SelectKey } from 'chakra-react-select';
import React from 'react';
import { Controller, useController, useFormState } from 'react-hook-form';
import { FormControl, FormLabel, FormWarning } from '../..';
export { CreatableSelect as CreatableSelectKey, chakraComponents as keychaineSelectComponents, Select as SelectKey } from 'chakra-react-select';
export function Select({ name, options, control, labelText, rules, ...rest }) {
    const { field: { onChange, onBlur, value, ref } } = useController({
        control,
        name,
        rules: rules
    });
    const { errors } = useFormState({ control });
    return (React.createElement(FormControl, null,
        labelText && (React.createElement(FormLabel, { htmlFor: name, id: name + 'label', key: name + 'label' }, labelText)),
        React.createElement(SelectKey, { name: name, ref: ref, options: options, onChange: onChange, onBlur: onBlur, value: value, ...rest, styles: {
                menuPortal: (provided) => ({ ...provided, zIndex: 100 })
            }, "aria-labelledby": name + 'label' }),
        errors[name] && React.createElement(FormWarning, null, errors[name]?.message)));
}
const ControllerSelect = React.forwardRef(({ isRequired = false, name, control, labelText, options }, _) => {
    const { errors } = useFormState({ control });
    return (React.createElement(FormControl, { isRequired: isRequired },
        labelText && (React.createElement(FormLabel, { id: name + 'label', key: name + 'label' }, labelText)),
        React.createElement(Controller, { control: control, name: name, render: ({ field: { onChange, onBlur, value, ref } }) => (React.createElement(React.Fragment, null,
                React.createElement(SelectKey, { onBlur: onBlur, onChange: onChange, value: value, options: options, styles: {
                        menuPortal: (provided) => ({ ...provided, zIndex: 100 })
                    }, key: name, id: name, ref: ref, name: name }),
                errors[name] && React.createElement(FormWarning, null, errors[name]?.message))) })));
});
ControllerSelect.displayName = 'controllerSelect';
export { ControllerSelect };
